// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum TapePattern {
  Stripes = 0,
  Grid = 1,
  Dots = 2,
  Plain = 3,
  Stars = 4,
  Flowers = 5,
  Hearts = 6,
  Waves = 7,
  Checkers = 8
}
